import { render, staticRenderFns } from "./RecommendationsInbox.vue?vue&type=template&id=2cab8895&scoped=true&"
import script from "./RecommendationsInbox.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecommendationsInbox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecommendationsInbox.vue?vue&type=style&index=0&id=2cab8895&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab8895",
  null
  
)

export default component.exports